export const firebaseConfig = {
    apiKey: "AIzaSyCRvQeiGpwf4m9214sTci3JqLnHmEFRhaw",
    authDomain: "datatown-analytics-18e5a.firebaseapp.com",
    projectId: "datatown-analytics-18e5a",
    storageBucket: "datatown-analytics-18e5a.appspot.com",
    messagingSenderId: "1056683256788",
    appId: "1:1056683256788:web:bbaaf63bdf988457e18441",
    measurementId: "G-EHNBM674ZW"
};